const breadCrumb = "Rendimento - Consulta do Rendimento";

const routes = [
  {
    path: "/consulta-rendimento",
    name: "consulta-rendimento",
    meta: {
      allowedPermissions: ["rendimento_turma_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultaRendimento/ConsultaRendimento/ConsultaRendimentoHome.vue"
      ),
  },

  // consuta por turma tipo RENDIMENTO
  {
    path: "/consulta-rendimento/turma/rendimento/fase/ensino/:ensinoId",
    name: "consulta-turma-rendimento-fase",
    meta: {
      allowedPermissions: ["rendimento_turma_ensino_show"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultaRendimento/ConsultaRendimento/ConsultaTurmaRendimentoFase.vue"
      ),
  },
  {
    path: "/consulta-rendimento/turma/rendimento/turno/fase/:faseId",
    name: "consulta-turma-rendimento-turno",
    meta: {
      allowedPermissions: ["rendimento_turma_ensino_fase_show"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultaRendimento/ConsultaRendimento/ConsultaTurmaRendimentoTurno.vue"
      ),
  },
  {
    path: "/consulta-rendimento/turma/rendimento/turma/turno/:turnoId",
    name: "consulta-turma-rendimento-turma",
    meta: {
      allowedPermissions: ["rendimento_turma_ensino_fase_turno_show"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultaRendimento/ConsultaRendimento/ConsultaTurmaRendimentoTurma.vue"
      ),
  },

  // consuta por turma tipo MOVIMENTO
  {
    path: "/consulta-rendimento/turma/movimento/fase/ensino/:ensinoId",
    name: "consulta-turma-movimento-fase",
    meta: {
      allowedPermissions: ["rendimento_turma_ensino_show"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultaRendimento/ConsultaRendimento/ConsultaTurmaMovimentoFase.vue"
      ),
  },
  {
    path: "/consulta-rendimento/turma/movimento/turno/fase/:faseId",
    name: "consulta-turma-movimento-turno",
    meta: {
      allowedPermissions: ["rendimento_turma_ensino_fase_show"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultaRendimento/ConsultaRendimento/ConsultaTurmaMovimentoTurno.vue"
      ),
  },
  {
    path: "/consulta-rendimento/turma/movimento/turma/turno/:turnoId",
    name: "consulta-turma-movimento-turma",
    meta: {
      allowedPermissions: ["rendimento_turma_ensino_fase_turno_show"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultaRendimento/ConsultaRendimento/ConsultaTurmaMovimentoTurma.vue"
      ),
  },

  // consuta por turma tipo DETALHE
  {
    path: "/consulta-rendimento/turma/detalhe/fase/ensino/:ensinoId",
    name: "consulta-turma-detalhe-fase",
    meta: {
      allowedPermissions: ["rendimento_turma_ensino_show"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultaRendimento/ConsultaRendimento/ConsultaTurmaDetalheFase.vue"
      ),
  },
  {
    path: "/consulta-rendimento/turma/detalhe/turno/fase/:faseId",
    name: "consulta-turma-detalhe-turno",
    meta: {
      allowedPermissions: ["rendimento_turma_ensino_fase_show"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultaRendimento/ConsultaRendimento/ConsultaTurmaDetalheTurno.vue"
      ),
  },
  {
    path: "/consulta-rendimento/turma/detalhe/turma/turno/:turnoId",
    name: "consulta-turma-detalhe-turma",
    meta: {
      allowedPermissions: ["rendimento_turma_ensino_fase_turno_show"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultaRendimento/ConsultaRendimento/ConsultaTurmaDetalheTurma.vue"
      ),
  },

  // consulta por disciplina
  {
    path: "/consulta-rendimento/disciplina/fase/ensino/:ensinoId",
    name: "consulta-disciplina-rendimento-fase",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultaRendimento/ConsultaRendimento/ConsultaDisciplinaRendimentoFase.vue"
      ),
  },
  {
    path: "/consulta-rendimento/disciplina/turno/fase/:faseId",
    name: "consulta-disciplina-rendimento-turno",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultaRendimento/ConsultaRendimento/ConsultaDisciplinaRendimentoTurno.vue"
      ),
  },
  {
    path: "/consulta-rendimento/disciplina/turma/turno/:turnoId",
    name: "consulta-disciplina-rendimento-turma",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultaRendimento/ConsultaRendimento/ConsultaDisciplinaRendimentoTurma.vue"
      ),
  },
];

export default routes;
